export const buildPaginationUrl = (pathname, page) => {
  const cleanPath = pathname.replace(/\/page\/\d+/, "");

  if (page === 1) {
    return cleanPath;
  }

  return `${cleanPath}/page/${page}`;
};
